import state from './file.state'
import mutations from './file.mutations'
import actions from './file.actions'
import getters from './file.getters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



//////////////////
// WEBPACK FOOTER
// ./state/file/file.module.js
// module id = null
// module chunks = 